var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isProductPreviewModalOpen && _vm.initProductId)?_c('ProductPreviewModal',{attrs:{"init-product-id":_vm.initProductId,"product-group-ids":_vm.productGroupIds},on:{"closeModal":_vm.closeModal}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }